const MONTH_LABELS = ["Feb", "Mar", "Apr", "May", "Jun", "Jul"];

/**
 * Ink-dark right half of the auth screen: the product as ambience —
 * a large net-worth figure and rising sparkline with illustrative
 * numbers. Purely decorative; hidden on small screens by AuthLayout.
 */
export default function AuthShowcasePanel() {
  return (
    <div className="flex h-full flex-col justify-center bg-vaulzo-ink px-14 py-12 text-white">
      <div>
        <div className="mb-5 text-[12px] uppercase tracking-[0.14em] text-white/40">
          Net worth
        </div>
        <div className="num text-[52px] font-bold leading-[0.92] tracking-[-0.045em] xl:text-[64px]">
          ₹86,42,500
        </div>
        <div className="num mt-4 text-[15px] font-semibold text-vaulzo-success">
          ↑ ₹4,18,300 · 5.09%
        </div>
      </div>

      <div className="mt-12">
        <Sparkline />
        <div className="mt-3 flex justify-between text-[11px] text-white/30">
          {MONTH_LABELS.map((m) => (
            <span key={m}>{m}</span>
          ))}
        </div>
      </div>

      <p className="mt-14 max-w-xs text-sm leading-relaxed text-white/45">
        Assets, debts, and allocation — one calm dashboard that shows where
        you stand and how it's changing.
      </p>
    </div>
  );
}

/** Rising net-worth curve tuned for the dark panel. */
function Sparkline() {
  return (
    <svg
      viewBox="0 0 600 104"
      className="h-[104px] w-full"
      preserveAspectRatio="none"
      aria-hidden
    >
      <defs>
        <linearGradient id="auth-nwg" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="#8FA0C4" stopOpacity="0.22" />
          <stop offset="100%" stopColor="#8FA0C4" stopOpacity="0" />
        </linearGradient>
      </defs>
      <path
        d="M0 88 C40 84, 70 72, 105 74 S 170 60, 210 62 S 280 44, 320 48 S 390 30, 430 34 S 500 16, 545 14 L 600 8"
        fill="none"
        stroke="#8FA0C4"
        strokeWidth="2"
        strokeLinecap="round"
        vectorEffect="non-scaling-stroke"
      />
      <path
        d="M0 88 C40 84, 70 72, 105 74 S 170 60, 210 62 S 280 44, 320 48 S 390 30, 430 34 S 500 16, 545 14 L 600 8 L 600 104 L 0 104 Z"
        fill="url(#auth-nwg)"
      />
    </svg>
  );
}
